<template>
  <div class="layout-container">
    <!-- 左侧菜单 -->
    <div class="sidebar-container" :class="{ 'is-collapse': isCollapse }">
      <Sidebar :is-collapse="isCollapse" @toggle="toggleCollapse" @login="handleLogin" />
    </div>

    <!-- 右侧主内容区 -->
    <div class="main-container" :class="{ 'is-collapse': isCollapse }">
      <!-- 内容区域 -->
      <div class="content-area" :class="{ 'content-area--page-scroll': pageHandlesScroll }">
        <router-view v-slot="{ Component, route: viewRoute }">
          <keep-alive include="CommunityActivity">
            <component
              :is="Component"
              v-if="Component"
              :key="
                viewRoute.meta.keepAlive
                  ? viewRoute.name
                  : viewRoute.fullPath
              "
            />
          </keep-alive>
        </router-view>
      </div>
    </div>

    <!-- 全局创建项目弹窗 -->
    <CreateProjectDialog />

    <!-- 社群弹窗 -->
    <CommunityDialog />

    <!-- 个人信息弹窗 -->
    <ProfileDialog />

    <!-- 消息中心：侧栏列表 + 详情弹窗（详情 z-index 高于列表） -->
    <MessageCenter />
  </div>
</template>

<script setup>
import { ref, provide, computed } from "vue";
import { useRouter, useRoute } from "vue-router";
import Sidebar from "./components/Sidebar.vue";
import CreateProjectDialog from "@/components/CreateProjectDialog.vue";
import CommunityDialog from "@/components/CommunityDialog.vue";
import ProfileDialog from "@/components/ProfileDialog.vue";
import MessageCenter from "@/components/MessageCenter.vue";

defineOptions({
  name: "Layout",
});

const router = useRouter();
const route = useRoute();
const isCollapse = ref(false);

/** 页面内部自管滚动（如社区左侧 feed），避免与 content-area 双滚动 */
const pageHandlesScroll = computed(() => route.path.startsWith("/community"));

function toggleCollapse() {
  isCollapse.value = !isCollapse.value;
}

function setCollapse(value) {
  isCollapse.value = value;
}

function handleLogin() {
  router.push("/login");
}

provide("setCollapse", setCollapse);
</script>

<style lang="scss" scoped>
.layout-container {
  display: flex;
  height: 100vh;
  background-color: #1a1a1a;
}

.sidebar-container {
  width: 200px;
  height: 100%;
  background-color: #1e1e1e;
  transition: width 0.3s ease;
  flex-shrink: 0;
  border-right: 1px solid #2d2d2d;

  &.is-collapse {
    width: 64px;
  }
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content-area {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  scrollbar-gutter: stable;
  background-color: #1a1a1a;

  &.content-area--page-scroll {
    overflow: hidden;
  }

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #3d3d3d;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background-color: #1a1a1a;
  }
}
</style>
